import React from "react";
import TableauVisualize from "../../Components/TableauVisualize";

function RegReports() {
  const reportLink =
    "https://dub01.online.tableau.com/#/site/infotrace/views/CustomerAnalysis/Registrations?:iid=1";
  const jwtToken =
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCIsImtpZCI6IjMxOTVjYmNiLTUzMjctNDEyOS1hMWZjLTAzM2NhN2Q4NmNhZSIsImlzcyI6ImM0MDlmYTk2LTBiYjYtNDNjMi05NWVlLTRjZjZjZGMyOGMwOSJ9.eyJpc3MiOiJjNDA5ZmE5Ni0wYmI2LTQzYzItOTVlZS00Y2Y2Y2RjMjhjMDkiLCJzdWIiOiJhbmFseXRpY3NAb25mb25tb2JpbGUuY29tIiwiYXVkIjoidGFibGVhdSIsImV4cCI6MTc2NTQ2MDE2NS41NywiaWF0IjoxNzY1NDU5ODY1LjU3LCJqdGkiOiI5YmViNmMwMS0xMDBmLTQwMGYtYWY0Zi1hZDY1OTY4ODQyYzkiLCJzY3AiOlsidGFibGVhdTp2aWV3czplbWJlZCIsInRhYmxlYXU6bWV0cmljczplbWJlZCJdfQ.eXJQSYmz_0H_aHoM0RHZTisP1SIxL6SFXm4DPzUhGUw";
  return (
    <div>
      <TableauVisualize link={reportLink} token={jwtToken} />
    </div>
  );
}

export default RegReports;
